import { expected, parseToolkitListingID } from '@aloft/toolkit-shared';

import { ReferenceViewID, ReferenceViewIDParsed } from './types.ts';

const TKRV_REGEX = new RegExp(/^tkrv:(subject|comparable:(.*))$/);

export function parseReferenceViewID(id: ReferenceViewID): ReferenceViewIDParsed;
export function parseReferenceViewID(id: string): ReferenceViewIDParsed | null;
export function parseReferenceViewID(idInput: string): ReferenceViewIDParsed | null {
  const matches = idInput.match(TKRV_REGEX);
  if (!matches) {
    return parseToolkitListingID(idInput);
  }

  if (matches[1] === 'subject') {
    return { type: 'subject' };
  }
  return {
    type: 'comparable',
    compID: expected(matches[2]),
  };
}
